// export const url = "http://192.168.1.33:3014" //Local
// export const url = "https://ssvwsadmin.opentech4u.co.in" // Production

// export const url = "https://bdccbshg.opentech4u.co.in/v1" //Local Wrong For Live

// export const url = "https://ssvwsadmin.opentech4u.co.in" //Local Lokesh
// export const url = "http://192.168.1.60:3017/v1"; //Local Lokesh
// export const url_bdccb = "http://192.168.1.60:3017/v1"; //Local Lokesh

// export const url = "http://192.168.1.33:3017/v1" //Local Sayantika
// export const url_bdccb = "http://192.168.1.33:3017/v1" //Local Sayantika

export const url = "https://bdccbshg.opentech4u.co.in/v1"; //UAT
export const url_bdccb = "https://bdccbshg.opentech4u.co.in/v1"; //UAT
